const DISABLE_SELECT_TOOL_NOTIFICATION = 'DISABLE_SELECT_TOOL_NOTIFICATION';
const ENABLE_SELECT_TOOL_NOTIFICATION = 'ENABLE_SELECT_TOOL_NOTIFICATION';
const SAVE_NOTIFICATION = 'SAVE_NOTIFICATION';
const SECONDS_TO_SHOW_NOTIFICATIONS = 4;

export default {
  DISABLE_SELECT_TOOL_NOTIFICATION,
  ENABLE_SELECT_TOOL_NOTIFICATION,
  SAVE_NOTIFICATION,
  SECONDS_TO_SHOW_NOTIFICATIONS,
};
